
import { AfterViewInit, Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../Core/services/api.service';
import { AuthenticationService } from '../../Core/services/authentication.service';
import { ToastService } from '../../Core/services/toast.service';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StorageService } from '../../Core/services/storage.service';


@Component({
  selector: 'app-login',
  imports: [
    NgbModule, ReactiveFormsModule, CommonModule, FormsModule,
    RouterModule,
],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: true
})
export class LoginComponent implements OnInit {

  // private fb = inject(FormBuilder);
  // private router = inject(Router);
  loginForm!: FormGroup;
  url: string;
  params: { email: any; password: any; };
  role: any;
  token: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _apiService: ApiService,
    private authService: AuthenticationService,
    private _toast: ToastService,
    private storageService: StorageService
  ) {  this.loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });
  this.url = this.router?.url?.slice(1);
}

  // UI state
  readonly loading = signal(false);
  readonly apiError = signal<string | null>(null);
  readonly showPwd = signal(false);



  ngOnInit() {

  }

  dirty(control: 'email'|'password'){ return this.loginForm.controls[control].touched; }
  togglePwd(){ this.showPwd.update(v => !v); }

  submit(){
    this.apiError.set(null);
    if (this.loginForm.invalid) { this.loginForm.markAllAsTouched(); return; }
    this.loading.set(true);

    const { email, password } = this.loginForm.getRawValue();
    this.params = {
      email: email,
      password: password
    }
    this._apiService.getLogin(this.params).subscribe((res: any) => {
      console.log(res, "LOGIN");
      if(res.status) {
        if (['SUPER_ADMIN', 'MASTER_ADMIN', 'OWNER', 'AGENT', 'ADMIN'].includes(res?.data.role)) {
          this.role = res?.data.role
          this.authService.saveUserData(res?.data);
          this._toast.showSuccess("Login Successful")
          sessionStorage.setItem('loggedIn', 'true')
          // sessionStorage.setItem('firstName', res.data.firstName)
          // sessionStorage.setItem('role', res?.data.role)
          // sessionStorage.setItem('lastName', res.data.lastName)
          this.token = res?.data.token;
          // sessionStorage.setItem('token', this.token);

          document.cookie = `username=${email}; path=/`;
          document.cookie = `password=${password}; path=/`;
          this.userNavigation(res?.data.token)
        } else {
         this._toast.showError("Not a authorise user")
         this.loading.set(false);
        }
      } else {
        this.loading.set(false);
      }

      // }, 300000);
    },
      (err: any) => {
        this._toast.showError(`${err.error.message}`)
        this.loading.set(false);
      }
    )
  }



  userNavigation(token:any) {
    // this.router.navigate(["/select"]);
    if(this.role == 'OWNER' || this.role == 'MASTER_ADMIN') {
      this.storageService.setTenantKey('rateloc_pvt_ltd_8kwehtwu');
    //   this.router.navigate(["/expenses"]);
    // // } else if (this.role == 'RL_ROLE_ADMIN') {
    // //   this.authService.setLoginAuthentication(token, 'type');
    // //    this.authService.setUserRoles(['RL_ROLE_ADMIN', ]);
    // //    this.router.navigate(["/dashboard"]);
    // } else if(this.role == 'MASTER_ADMIN') {
    //   this.authService.setLoginAuthentication(token, 'type');
    //   this.router.navigate(["/crm"]);
    }
    this.authService.setLoginAuthentication(token, 'type');
    this.storageService.setUserRoles(this.role);
    this.router.navigate(["/crm"]);
  }
}
